import { Anchor, createPolymorphicComponent, AnchorProps } from '@mantine/core';
import { forwardRef } from 'react';

import linkStyles from './Link.module.css';
import { joinClassNames } from 'utils/joinClassNames';

export type LinkProps = AnchorProps;

const _Link = forwardRef<HTMLAnchorElement, LinkProps>(({ className, ...others }, ref) => (
    <Anchor {...others} ref={ref} className={joinClassNames(linkStyles.root, className)}></Anchor>
));

_Link.displayName = 'Link';

const Link = createPolymorphicComponent<'a', LinkProps>(_Link);

export { Link };
